module.exports = __webpack_public_path__ + "static/img/m5.bf6d666.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m5.png
// module id = 9y9j
// module chunks = 12